module.exports = __webpack_public_path__ + "static/media/USYGY100092.11c8d4d8.jpg";